module.exports = __webpack_public_path__ + "static/media/member (2).284bca60.png";